import { render, staticRenderFns } from "./AuthFooter.vue?vue&type=template&id=95af8f72"
import script from "./AuthFooter.vue?vue&type=script&lang=js"
export * from "./AuthFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports